<script>
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import ofirma from "@/models/ofirma";
import Eye from './eye.vue';
export default {
  mixins: [apibtoast, apigeneric, ofirma],
  page: {
    title: "İhaleler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Eye,
  },
  data() {
    return {
      DefaultPage: 1,
      DefaultPage2: 1,
      Page: {
        PageNumber: "1",
        PageSize: "999",
        PageDataSize: "1",
      },
      Page2: {
        PageNumber: "1",
        PageSize: "999",
        PageDataSize: "1",
      },
      TableData: {},
      TableData2: [],
      TableData3: [],
      YayinlananIhaleler: {},
      DataUpdate: "",
      Alimturu: [],
      YaklasikMaliyetAlimTuru: null,
      YaklasikMaliyetBaslangicTarih: null,
      YaklasikMaliyetBitisTarih: null,
      TamamlananAlimTuru: null,
      TamamlananBaslangicTarih: null,
      TamamlananBitisTarih: null,
    };
  },
  methods: {
    Get() {
      this.YaklasikMaliyetGet()
      this.TamamlananGet()
    },
    YaklasikMaliyetGet() {
      var Filter = ""
      if (this.YaklasikMaliyetBaslangicTarih != "" && this.YaklasikMaliyetBaslangicTarih != null) {
        Filter += "&Dosyaacilistarih_ilk=" + this.YaklasikMaliyetBaslangicTarih;
      }
      if (this.YaklasikMaliyetBitisTarih != "" && this.YaklasikMaliyetBitisTarih != null) {
        Filter += "&Dosyaacilistarih_son=" + this.YaklasikMaliyetBitisTarih;
      }
      if (this.YaklasikMaliyetAlimTuru != "" && this.YaklasikMaliyetAlimTuru != null) {
        Filter += "&Alimturu=" + this.YaklasikMaliyetAlimTuru;
      }

      this.ActionsFilterGet({
        Service: "satdosya/getsatdosyawebsite",
        Page: this.Page,
        Filter: "&Yaklasikmaliyetwebsite=true" + Filter,
      }).then((res) => {
        this.TableData = res.Data.Dosyalar;
  //      this.Page.PageDataSize = res.TotalCount;
      });
    },
    TamamlananGet() {
      var Filter = ""
      if (this.TamamlananBaslangicTarih != "" && this.TamamlananBaslangicTarih != null) {
        Filter += "&Dosyaacilistarih_ilk=" + this.TamamlananBaslangicTarih;
      }
      if (this.TamamlananBitisTarih != "" && this.TamamlananBitisTarih != null) {
        Filter += "&Dosyaacilistarih_son=" + this.TamamlananBitisTarih;
      }
      if (this.TamamlananAlimTuru != "" && this.TamamlananAlimTuru != null) {
        Filter += "&Alimturu=" + this.TamamlananAlimTuru;
      }
      this.ActionsFilterGet({
        Service: "satdosya/getsatdosyawebsite",
        Page: this.Page2,
        Filter: "&Tamamlandi=true" + Filter,
      }).then((res) => {
        this.YayinlananIhaleler = res.Data.Dosyalar
        for(var Data in this.YayinlananIhaleler){
          if(this.YayinlananIhaleler[Data].IsEkap == true && this.YayinlananIhaleler[Data].WebSitedenFiyat == true){
            this.TableData3.push(this.YayinlananIhaleler[Data]);
          }if((this.YayinlananIhaleler[Data].IsEkap == false || this.YayinlananIhaleler[Data].IsEkap == null) && this.YayinlananIhaleler[Data].WebSitedenFiyat == true)
          {
            this.TableData2.push(this.YayinlananIhaleler[Data]);
          }
        }
      });
    }
  },
  created() {
    this.ActionsSabitGet(1548).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.Alimturu.push({ Id: res.Data[i].Id, Value: res.Data[i].Value });
      }
    });
  }
};
</script>

<template>
  <Loader>
    <div class="account-pages my-5 pt-5">
      <div class="container">

        <div class="row">
          <div class="col-xl-12">
            <div class="card">
              <div class="card-body">
                <div class="row" style="text-align: end;">
                  <div class="col-md-8"></div>
                  <div class="col-md-4">


                <b-button style="border: none; font-size: 12px; " variant="primary" v-tooltip="'Döküman'" target="_blank"
                                  :href="$config.FILES_URL + 'sat/SatinAlmaFirma.pdf'">
                                      <i class="fas fa-eye fa-xs"></i>
                                      Firmalar İçin Kullanım Klavuzu</b-button> 
                </div>
              </div>
                <b-tabs content-class="p-3 text-muted">
                  <b-tab active class="border-0">
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="fas fa-home"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">Satın Alma İlanları</span>
                    </template>
                    <div class="row">
                      <div class="col mb-3 ">
                        <label class="col-md-12 col-form-label">Başlangıç Tarihi</label>
                        <b-form-input id="datebs" v-model="YaklasikMaliyetBaslangicTarih" value=""
                          type="date"></b-form-input>
                      </div>
                      <div class="col mb-3 ">
                        <label class="col-md-12 col-form-label">Bitiş Tarihi</label>
                        <b-form-input id="datebs" v-model="YaklasikMaliyetBitisTarih" value="" type="date"></b-form-input>
                      </div>
                      <div class="col mb-3 ">
                        <label class="col-md-12 col-form-label">Alım Türü</label>
                        <select v-model="YaklasikMaliyetAlimTuru" class="form-select" type="text">
                          <option value="">Seçiniz</option>
                          <option v-for="alim in Alimturu" :key="alim.Id" :value="alim.Id">
                            {{ alim.Value }}
                          </option>
                        </select>
                      </div>
                      <div class="col mb-3 ">
                        <b-button @click="YaklasikMaliyetGet()" class="btn btn-primary mt-4"
                          variant="primary">Filtrele</b-button>
                      </div>
                    </div>
                    <div class="table-responsive"> <b-card no-body class="mb-1">
                        <table class="table mb-0">
                          <thead class="table-light">
                            <tr>
                              <th>Mal/Hizmet/Yapım</th>
                              <th>Dosya Adı</th>
                              <th>Dosya Açılış Tarihi</th>
                              <th>Son Teklif Tarihi</th>
                              <th>İhaleyi Yapan Makam</th>
                              <th>Alım Türü</th>

                              <th style="width: 170px; text-align: center;">İhale Türü</th>

                              <th style="text-align: center;">İşlem</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template v-for="(Data, index) in TableData">
                              <tr :key="index">
                                <td>
                                  <b-card-header header-tag="header" role="tab">
                                    <h6 class="m-0">
                                      <a v-b-toggle="'accordion-' + index" class="text-dark"
                                        href="javascript: void(0);">İhtiyaç
                                        Listesi</a>
                                    </h6>
                                  </b-card-header>
                                </td>
                                <th scope="row">{{ Data.Dosyaadi }}</th>
                                <td>{{ Data.Dosyaacilistarih | formatDateTable }}</td>
                                <td>{{ Data.Sontekliftarih | formatDateTable }}</td>
                                <td>{{ Data.Birimadi }}</td>
                                <td>{{ Data.Alimturuvalue }}</td>
                                <td>{{ Data.Ihaleturuvalue }}</td>
                                <td style="width: 85px">
                                  <b-button-group>
                                    <b-button variant="success" v-tooltip="'Teklifte Bulun'" target="_blank"
                                      :href="Data.Websiteverigirislink  + Data.Id">
                                      <i class="bx bx-link"></i>
                                    </b-button>
                                    <b-button v-if="Data.Dosyamalzemebelge" style="border: none; font-size: 16px;" variant="primary" v-tooltip="'Döküman'" target="_blank"
                                  :href="$config.FILES_URL + 'sat/' + Data.Dosyamalzemebelge">
                                      <i class="fas fa-eye fa-xs"></i>
                                    </b-button> 
                                  </b-button-group> 
                                </td>
                              </tr>
                              <tr :key="index">
                                <td colspan="6">

                                  <b-collapse :id="'accordion-' + index" accordion="my-accordion" role="tabpanel">

                                    <b-card-body>
                                      <div class="table-responsive">
                                        <table class="table mb-0">
                                          <thead class="table-light">
                                            <tr>
                                              <th>Sıra No</th>
                                              <th>Mal/Hizmet/Yapım Adı
                                              </th>
                                              <th>Adet</th>
                                              <th>Ölçü Birimi</th>
                                              <th>Açıklama</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr v-for="(Data, index) in Data.SatDosyaMalzeme" :key="index">
                                              <th>{{ Data.Sirano }}</th>
                                              <td>{{ Data.MalzemeAdi }}
                                                <button v-if="Data.Image" style="border: none; font-size: 16px;" variant="success" v-tooltip="'Malzeme Görseli'" target="_blank"
                                                v-b-modal.eye @click="(DataUpdate = Data)">
                                      <i class="fas fa-eye"></i>
                                    </button>
                                              </td>
                                              <td>{{ Data.Adet }}</td>
                                              <td>{{ Data.Olcubirimiadi }}</td>
                                              <td>{{ Data.Aciklama }}</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </b-card-body>
                                  </b-collapse>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </b-card>
                      <br />
                      <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                        :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
                        @input="ChangePage(DefaultPage)"> </b-pagination>
                    </div>

                  </b-tab>
                  <b-tab>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="far fa-user"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">Tamamlanan Satın Alma Sonuçları</span>
                    </template>
                    <div class="row">
                      <div class="col mb-3 ">
                        <label class="col-md-12 col-form-label">Başlangıç Tarihi</label>
                        <b-form-input id="datebs" v-model="TamamlananBaslangicTarih" value=""
                          type="date"></b-form-input>
                      </div>
                      <div class="col mb-3 ">
                        <label class="col-md-12 col-form-label">Bitiş Tarihi</label>
                        <b-form-input id="datebs" v-model="TamamlananBitisTarih" value="" type="date"></b-form-input>
                      </div>
                      <div class="col mb-3 ">
                        <label class="col-md-12 col-form-label">Alım Türü</label>
                        <select v-model="TamamlananAlimTuru" class="form-select" type="text">
                          <option value="">Seçiniz</option>
                          <option v-for="alim in Alimturu" :key="alim.Id" :value="alim.Id">
                            {{ alim.Value }}
                          </option>
                        </select>
                      </div>
                      <div class="col mb-3 ">
                        <b-button @click="TamamlananGet()" class="btn btn-primary mt-4"
                          variant="primary">Filtrele</b-button>
                      </div>
                    </div>
                    <div class="table-responsive"> <b-card no-body class="mb-1">
                        <table class="table mb-0">
                          <thead class="table-light">
                            <tr>
                              <th>Mal/Hizmet/Yapım</th>
                              <th>Dosya Adı</th>
                              <th>Dosya Açılış Tarihi</th>
                              <th>İhaleyi Yapan Makam</th>
                              <th>Alım Türü</th>

                              <th style="width: 170px; text-align: center;">İhale Türü</th>

                            </tr>
                          </thead>
                          <tbody>
                            <template v-for="(Data, index) in TableData2">
                              <tr :key="index" v-if="Data.WebSitedenFiyat == true">
                                <td>
                                  <b-card-header header-tag="header" role="tab">
                                    <h6 class="m-0">
                                      <a v-b-toggle.accordion-3 class="text-dark" href="javascript: void(0);">İhtiyaç
                                        Listesi</a>
                                    </h6>
                                  </b-card-header>
                                </td>
                                <th scope="row">{{ Data.Dosyaadi }}</th>
                                <td>{{ Data.Dosyaacilistarih | formatDateTable }}</td>
                                <td>{{ Data.Birimadi }}</td>
                                <td>{{ Data.Alimturuvalue }}</td>

                                <td>{{ Data.Ihaleturuvalue }}</td>


                              </tr>
                              <tr :key="index">
                                <td colspan="6">

                                  <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                                    <b-card-body>
                                      <div class="table-responsive">
                                        <table class="table mb-0">
                                          <thead class="table-light">
                                            <tr>
                                              <th>Sıra No</th>
                                              <th>Mal/Hizmet/Yapım Adı</th>
                                              <th>Adet</th>
                                              <th>Ölçü Birimi</th>
                                              <th>Açıklama</th>
                                              <th>Kazanan Firma</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr v-for="(Data, index) in Data.SatDosyaMalzeme" :key="index">
                                              <th>{{ Data.Sirano }}</th>
                                              <td>{{ Data.MalzemeAdi }}</td>
                                              <td>{{ Data.Adet }}</td>
                                              <td>{{ Data.Olcubirimiadi }}</td>
                                              <td>{{ Data.Aciklama }}</td>
                                              <td>{{ Data.Kazananfirmaadi }}</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </b-card-body>
                                  </b-collapse>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </b-card>
                      <br />
                      <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage2"
                        :total-rows="Page2.PageDataSize" :per-page="Page2.PageSize" aria-controls="my-table"
                        @input="ChangePage(DefaultPage2)"> </b-pagination>
                    </div>
                  </b-tab>
                  <b-tab>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="far fa-user"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">İhale İlan ve Sonuçları (EKAP)</span>
                    </template>
                    <div class="row">
                      <div class="col mb-3 ">
                        <label class="col-md-12 col-form-label">Başlangıç Tarihi</label>
                        <b-form-input id="datebs" v-model="TamamlananBaslangicTarih" value=""
                          type="date"></b-form-input>
                      </div>
                      <div class="col mb-3 ">
                        <label class="col-md-12 col-form-label">Bitiş Tarihi</label>
                        <b-form-input id="datebs" v-model="TamamlananBitisTarih" value="" type="date"></b-form-input>
                      </div>
                      <div class="col mb-3 ">
                        <label class="col-md-12 col-form-label">Alım Türü</label>
                        <select v-model="TamamlananAlimTuru" class="form-select" type="text">
                          <option value="">Seçiniz</option>
                          <option v-for="alim in Alimturu" :key="alim.Id" :value="alim.Id">
                            {{ alim.Value }}
                          </option>
                        </select>
                      </div>
                      <div class="col mb-3 ">
                        <b-button @click="TamamlananGet()" class="btn btn-primary mt-4"
                          variant="primary">Filtrele</b-button>
                      </div>
                    </div>
                    <div class="table-responsive"> <b-card no-body class="mb-1">
                        <table class="table mb-0">
                          <thead class="table-light">
                            <tr>
                              <th>Mal/Hizmet/Yapım</th>
                              <th>Dosya Adı</th>
                              <th>EKAP No</th>
                              <th>Dosya Açılış Tarihi</th>
                              <th>İhaleyi Yapan Makam</th>
                              <th>Alım Türü</th>

                              <th style="width: 170px; text-align: center;">İhale Türü</th>

                            </tr>
                          </thead>
                          <tbody>
                            <template v-for="(Data, index) in TableData3">
                              <tr :key="index">
                                <td>
                                  <b-card-header header-tag="header" role="tab">
                                    <h6 class="m-0">
                                      <a v-b-toggle.accordion-3 class="text-dark" href="javascript: void(0);">Mal/Hizmet/Yapım
                                        Listesi</a>
                                    </h6>
                                  </b-card-header>
                                </td>
                                <th scope="row">{{ Data.Dosyaadi }}</th>
                                <td>{{ Data.EkapNo }}</td>
                                <td>{{ Data.Dosyaacilistarih | formatDateTable }}</td>
                                <td>{{ Data.Birimadi }}</td>
                                <td>{{ Data.Alimturuvalue }}</td>
                                <td>{{ Data.Ihaleturuvalue }}</td>


                              </tr>
                              <tr :key="index">
                                <td colspan="6">

                                  <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                                    <b-card-body>
                                      <div class="table-responsive">
                                        <table class="table mb-0">
                                          <thead class="table-light">
                                            <tr>
                                              <th>Sıra No</th>
                                              <th>Mal/Hizmet/Yapım Adı</th>
                                              <th>Adet</th>
                                              <th>Ölçü Birimi</th>
                                              <th>Açıklama</th>
                                              <th>Kazanan Firma</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr v-for="(Data, index) in Data.SatDosyaMalzeme" :key="index">
                                              <th>{{ Data.Sirano }}</th>
                                              <td>{{ Data.MalzemeAdi }}</td>
                                              <td>{{ Data.Adet }}</td>
                                              <td>{{ Data.Olcubirimiadi }}</td>
                                              <td>{{ Data.Aciklama }}</td>
                                              <td>{{ Data.Kazananfirmaadi }}</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </b-card-body>
                                  </b-collapse>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </b-card>
                      <br />
                      <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage2"
                        :total-rows="Page2.PageDataSize" :per-page="Page2.PageSize" aria-controls="my-table"
                        @input="ChangePage(DefaultPage2)"> </b-pagination>
                    </div>
                  </b-tab>

                </b-tabs>

              </div>
            </div>
          </div>
        </div>



      </div>
    </div>
    <eye :Id="DataUpdate"></eye>
  </Loader>
</template>
